import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";

export const adminMenuList = [
  {
    name: "Administration",
    icon: AdminPanelSettingsOutlinedIcon,
    link: "administration",
  },
  {
    name: "Customer",
    icon: PeopleAltOutlinedIcon,
    link: "customer",
  },
  {
    name: "Medicines",
    icon: MedicationOutlinedIcon,
    link: "medicines",
  },
  { name: "AI translations", icon: TranslateOutlinedIcon, link: "ai-translations" },
  { name: "SEO keywords", icon: QueryStatsIcon, link: "seo-keywords", permissionScopes: ["Medicines", "Translations"] },
  { name: "Medicine templates", icon: ArticleOutlinedIcon, link: "seo-templates", permissionScopes: ["Medicines", "Translations"] },
  { name: "SEO analytics", icon: AssessmentOutlinedIcon, link: "seo-analytics", permissionScopes: ["Medicines", "Translations"] },
  { name: "IP Access", icon: SecurityOutlinedIcon, link: "ip-access", ownerOnly: true },
  {
    name: "Review",
    icon: RateReviewOutlinedIcon,
    link: "review",
  },
  {
    name: "Orders",
    icon: ShoppingCartOutlinedIcon,
    link: "orders",
  },
  {
    name: "Delivery Methods",
    icon: LocalShippingOutlinedIcon,
    link: "delivery",
  },
  {
    name: "Payment Methods",
    icon: PaymentOutlinedIcon,
    link: "payment",
  },
  {
    name: "Reports",
    icon: AssessmentOutlinedIcon,
    link: "reports",
  },

  {
    name: "Blog",
    icon: ArticleOutlinedIcon,
    link: "blog",
  },
  {
    name: "Supplier",
    icon: HandshakeOutlinedIcon,
    link: "supplier",
  },
  {
    name: "Expanse Calculation",
    icon: CalculateOutlinedIcon,
    link: "expense-calc",
  },
  {
    name: "Website Settings",
    icon: PublicOutlinedIcon,
    link: "web-settings",
  },
];
